// extracted by mini-css-extract-plugin
module.exports = {"Item":"Main_Item__1hhp1","ShapeA":"Main_ShapeA__TKAL8","TallCurvyUnderline":"Main_TallCurvyUnderline__6djFc"};